import { render, staticRenderFns } from "./GapTable.vue?vue&type=template&id=2d0a9fe2&scoped=true"
import script from "./GapTable.vue?vue&type=script&lang=js"
export * from "./GapTable.vue?vue&type=script&lang=js"
import style0 from "./GapTable.vue?vue&type=style&index=0&id=2d0a9fe2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d0a9fe2",
  null
  
)

export default component.exports